import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AgendaPriority } from "../models/agendapriority"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AgendaPriorityService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'agendapriority/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllAgendaPriority(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<AgendaPriority>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllAgendaPriority?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewAgendaPriority(AgendaPriorityID?: string): Observable<Array<AgendaPriority>> {
    return this.httpService.get(this.apiEndpoint + 'viewAgendaPriority/' + (AgendaPriorityID ? AgendaPriorityID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveAgendaPriority(agendaprioritys: AgendaPriority): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveAgendaPriority/', agendaprioritys).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  } 

  deleteAgendaPriority(AgendaPriorityID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteAgendaPriority/' + (AgendaPriorityID ? AgendaPriorityID : '00000000-0000-0000-0000-000000000000'), AgendaPriorityID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(AgendaPriorityName?: string,AgendaPriorityId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?AgendaPriorityName=' + (AgendaPriorityName ? AgendaPriorityName : '')+ '&AgendaPriorityId=' + (AgendaPriorityId ? AgendaPriorityId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
